module.exports = __webpack_public_path__ + "img/balkanfood.9582e907.jpg";